import { createFileRoute } from "@tanstack/solid-router";
import { onMount } from "solid-js";
import { useNavbar } from "../../contexts/RootContext";

export const Route = createFileRoute("/about/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { setTitle } = useNavbar();

  onMount(() => {
    setTitle("Om");
  });

  return <div>Hello "/about/"!</div>;
}
